import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { IFile } from '@model/file';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

import { actionItemCommentsKey } from './useActionItemCommentsQuery';

interface IData {
  aiType: string;
  actionItemId: number;
  commentId: number;
}

const aiCommentDeleteFn = (data: IData) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/action-item/${data.actionItemId}/comment/${data.commentId}`, {
    data: {
      type: data.aiType,
    },
  });

export const useAiCommentDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: aiCommentDeleteFn,
    onSuccess: (data, variables) => {
      const actionItemId = variables.actionItemId;
      if (actionItemId) {
        queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
        queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
        queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
      }
    },
  });
};
